export const doctorStatusEnum = {
  ACTIVE: 0,
  INACTIVE: 1
}

export const doctorStatus = {
  [doctorStatusEnum.ACTIVE]: 'Active',
  [doctorStatusEnum.INACTIVE]: 'Inactive'
}
